import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import About from "../components/About";
import Journey from "../components/Journey";
import Stories from "../components/Stories";
import Gallery from "../components/Gallery";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import GiftOpening from "../components/GiftOpening";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#FDFBF7] text-[#2A1D15]">
      <GiftOpening />
      <Nav />
      <main>
        <Hero />
        <About />
        <Journey />
        <Stories />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
